import React, { useState } from 'react';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [radius, setRadius] = useState('5');
  const [address, setAddress] = useState('');

  const handleLogin = () => {
    if (username === 'triplejpproperty' && password === 'ScanFlood2025!') {
      setIsLoggedIn(true);
    } else {
      alert('Incorrect username or password');
    }
  };

  if (!isLoggedIn) {
    return (
      <div style={{ marginTop: 100, textAlign: 'center' }}>
        <h2>Triple JP Flood Scanner</h2>
        <input placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} /><br />
        <input placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} /><br />
        <button onClick={handleLogin}>Login</button>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 50, textAlign: 'center' }}>
      <h2>Flood Zone Comparison Tool</h2>
      <input
        placeholder="Enter address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        style={{ width: 300 }}
      />
      <br />
      <select value={radius} onChange={(e) => setRadius(e.target.value)}>
        <option value="1">1 mile</option>
        <option value="5">5 miles</option>
        <option value="10">10 miles</option>
        <option value="20">20 miles</option>
        <option value="50">50 miles</option>
        <option value="100">100 miles</option>
        <option value="1000">1000 miles</option>
      </select>
      <br />
      <button style={{ marginTop: 20 }}>Run Flood Zone Scan</button>
      <p style={{ marginTop: 20, fontStyle: 'italic' }}>[Map and export results will appear here]</p>
    </div>
  );
};

export default App;
